(function () {
  function init(root) {
    if (root.dataset.ready === "true") return;
    root.dataset.ready = "true";

    var scroller = root.querySelector(".sm-reviews__scroller");
    var prev = root.querySelector(".sm-reviews__nav--prev");
    var next = root.querySelector(".sm-reviews__nav--next");
    if (!scroller || !prev || !next) return;

    function addReadMore() {
      scroller.querySelectorAll(".sm-reviews__card").forEach(function (card) {
        if (card.querySelector(".sm-reviews__more")) return;
        var text = card.querySelector(".sm-reviews__text");
        if (!text || text.scrollHeight <= text.clientHeight + 2) return;
        var button = document.createElement("button");
        button.type = "button";
        button.className = "sm-reviews__more";
        button.textContent = "Read more";
        text.after(button);
        button.addEventListener("click", function () {
          var open = card.classList.toggle("is-open");
          button.textContent = open ? "Show less" : "Read more";
        });
      });
    }

    function stepSize() {
      var card = scroller.querySelector(".sm-reviews__card");
      if (!card) return 320;
      var styles = window.getComputedStyle(scroller);
      var gap = parseFloat(styles.columnGap || styles.gap) || 16;
      return card.getBoundingClientRect().width + gap;
    }

    function scrollByDir(dir) {
      var max = scroller.scrollWidth - scroller.clientWidth;
      if (dir > 0 && scroller.scrollLeft >= max - 8) {
        scroller.scrollTo({ left: 0, behavior: "smooth" });
        return;
      }
      if (dir < 0 && scroller.scrollLeft <= 8) {
        scroller.scrollTo({ left: max, behavior: "smooth" });
        return;
      }
      scroller.scrollBy({ left: dir * stepSize(), behavior: "smooth" });
    }

    prev.addEventListener("click", function () { scrollByDir(-1); });
    next.addEventListener("click", function () { scrollByDir(1); });

    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var autoplay = root.dataset.autoplay === "true" && !reduce;
    var delay = (parseInt(root.dataset.delay, 10) || 5) * 1000;
    var timer = null;

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      if (!autoplay || timer) return;
      timer = window.setInterval(function () { scrollByDir(1); }, delay);
    }

    root.addEventListener("mouseenter", stop);
    root.addEventListener("mouseleave", start);
    root.addEventListener("focusin", stop);
    root.addEventListener("focusout", function (event) {
      if (!root.contains(event.relatedTarget)) start();
    });
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) stop();
      else start();
    });

    window.requestAnimationFrame(addReadMore);
    window.addEventListener("load", addReadMore);
    start();
  }

  function boot() {
    document.querySelectorAll("[data-google-reviews]").forEach(init);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
